module.exports = __webpack_public_path__ + "static/img/200120.425794c1.png";